import { FileTextIcon, Trash2Icon } from 'lucide-react'

import { Button } from '@/components/ui'
import type { CaseDocument } from '@/modules/tools/bankruptcy/stores/types'
import { useDialogActions } from '@/stores'
import { formatNumber, humanizeText } from '@/utils'
import { DocumentLink } from './DocumentLink'
import { REMOVE_DOCUMENT_DIALOG_ID } from './RemoveDocumentDialog'

export const DocumentsPanel = ({
  filingId,
  documents,
  readOnly = false,
}: {
  filingId: number
  documents: CaseDocument[]
  readOnly?: boolean
}) => {
  const { openDialog } = useDialogActions()

  if (documents.length === 0) {
    return (
      <p className="rounded-lg border border-dashed p-4 text-center text-muted-foreground text-sm">
        No documents on this case yet.
      </p>
    )
  }

  return (
    <ul className="divide-y rounded-lg border">
      {documents.map((document) => (
        <li key={document.id} className="flex items-center gap-3 px-4 py-3">
          <FileTextIcon className="h-4 w-4 shrink-0 text-muted-foreground" />
          <div className="min-w-0 flex-1">
            <DocumentLink document={document} />
            <p className="text-muted-foreground text-xs">
              {formatNumber(document.numberOfPages)} pages ·{' '}
              {document.status ? humanizeText(document.status) : 'Not screened'}
            </p>
          </div>
          {!readOnly && (
            <Button
              theme="ghost"
              size="sm"
              isIcon
              className="text-muted-foreground hover:text-destructive"
              onClick={() =>
                openDialog(REMOVE_DOCUMENT_DIALOG_ID, {
                  filingId,
                  documentId: document.id,
                  fileName: document.fileName,
                })
              }
            >
              <Trash2Icon className="h-4 w-4" />
              <span className="sr-only">Remove document</span>
            </Button>
          )}
        </li>
      ))}
    </ul>
  )
}
